/*
    Para agregar Mixins
    import { mixinUse } from "@/libs/mixins";
    export default {
        name: "component",
        mixins: [ mixinUse ]
    }
*/
import store  from "@/store";

const EXP_DAYS = 60;

const goalsObj = [
    { name: "Fin a la Pobreza", img: require("@/assets/images/goals/goal-01.webp") },
    { name: "Hambre cero", img: require("@/assets/images/goals/goal-02.webp") },
    { name: "Salud y bienestar", img: require("@/assets/images/goals/goal-03.webp") },
    { name: "Educación de calidad", img: require("@/assets/images/goals/goal-04.webp") },
    { name: "Igualdad de género", img: require("@/assets/images/goals/goal-05.webp") },
    { name: "Agua limpia y saneamiento", img: require("@/assets/images/goals/goal-06.webp") },
    { name: "Energía asequible y no contaminante", img: require("@/assets/images/goals/goal-07.webp") },
    { name: "Trabajo decente y crecimiento económico", img: require("@/assets/images/goals/goal-08.webp") },
    { name: "Industria, innovación e infraestructura", img: require("@/assets/images/goals/goal-09.webp") },
    { name: "Reducción de las desigualdades", img: require("@/assets/images/goals/goal-10.webp") },
    { name: "Ciudades y comunidades sostenibles", img: require("@/assets/images/goals/goal-11.webp") },
    { name: "Producción y consumo responsables", img: require("@/assets/images/goals/goal-12.webp") },
    { name: "Acción por el clima", img: require("@/assets/images/goals/goal-13.webp") },
    { name: "Vida submarina", img: require("@/assets/images/goals/goal-14.webp") },
    { name: "Vida de ecosistemas terrestres", img: require("@/assets/images/goals/goal-15.webp") },
    { name: "Paz, justicia e instituciones sólidas", img: require("@/assets/images/goals/goal-16.webp") },
    { name: "Alianzas para lograr objetivos", img: require("@/assets/images/goals/goal-17.webp") }
];
const flags = [
    { name: "Chile", src: require("@/assets/images/flags/051-chile.svg") },
    { name: "Países Bajos", src: require("@/assets/images/flags/195-netherlands.svg") },
    { name: "México", src: require("@/assets/images/flags/239-mexico.svg") },
    { name: "Bélgica", src: require("@/assets/images/flags/054-belgium.svg") },
    { name: "Perú", src: require("@/assets/images/flags/074-peru.svg") },
    { name: "Estados Unidos", src: require("@/assets/images/flags/153-united-states-of-america.svg") },
    { name: "Nueva Zelanda", src: require("@/assets/images/flags/048-new-zealand.svg") },
    { name: "Argentina", src: require("@/assets/images/flags/064-argentina.svg") },
    { name: "España", src: require("@/assets/images/flags/044-spain.svg") },
    { name: "Colombia", src: require("@/assets/images/flags/062-colombia.svg") },
    { name: "Puerto Rico", src: require("@/assets/images/flags/005-puerto-rico.svg") },
    { name: "Alemania", src: require("@/assets/images/flags/066-germany.svg") },
    { name: "Brasil", src: require("@/assets/images/flags/250-brazil.svg") },
    { name: "Australia", src: require("@/assets/images/flags/130-australia.svg") },
    { name: "Venezuela", src: require("@/assets/images/flags/057-venezuela.svg") },
    { name: "Hong Kong", src: require("@/assets/images/flags/067-hong-kong.svg") },
    { name: "Bolivia", src: require("@/assets/images/flags/133-bolivia.svg") },
    { name: "Reino Unido", src: require("@/assets/images/flags/262-united-kingdom.svg") },
    { name: "Italia", src: require("@/assets/images/flags/011-italy.svg") },
    { name: "Uruguay", src: require("@/assets/images/flags/038-uruguay.svg") },
    { name: "Canadá", src: require("@/assets/images/flags/206-canada.svg") },
    { name: "Francia", src: require("@/assets/images/flags/077-france.svg") },
    { name: "Portugal", src: require("@/assets/images/flags/174-portugal.svg") },
    { name: "Ecuador", src: require("@/assets/images/flags/049-ecuador.svg") },
    { name: "Costa Rica", src: require("@/assets/images/flags/131-costa-rica.svg") },
    { name: "El Salvador", src: require("@/assets/images/flags/015-el-salvador.svg") },
    { name: "Haití", src: require("@/assets/images/flags/247-haiti.svg") },
    { name: "República Dominicana", src: require("@/assets/images/flags/018-dominican-republic.svg") },
    { name: "Honduras", src: require("@/assets/images/flags/027-honduras.svg") },
    { name: "Latinoamérica", src: require("@/assets/images/flags/419-latin-america.png") }

];
const benefits = [
    { name: "Horario Flexible", src: require("@/assets/icons/clock.svg") },
    { name: "Vestimenta Informal", src: require("@/assets/icons/sneakers.svg") },
    { name: "Computador", src: require("@/assets/icons/laptop.svg") },
    { name: "Cobertura de salud", src: require("@/assets/icons/heartbeat.svg") },
    { name: "Pre y Post natal Adicional a lo legal", src: require("@/assets/icons/maternity.svg") },
    { name: "Vacaciones Extras", src: require("@/assets/icons/sunbed.svg") },
    { name: "Ayuda con reubicación", src: require("@/assets/icons/cardboard-box.svg") },
];

const currentFile = {
    computed: {
        getPrivacyProtection() {
            // `${process.env.VUE_APP_ROOT_ASSETS}${process.env.VUE_APP_ASSETS_OTHERS_PATH}Política+de+Privacidad+Datos+personales+y+Condiciones+de+Uso.pdf`
            return `${process.env.VUE_APP_ROOT_ASSETS}${process.env.VUE_APP_ASSETS_OTHERS_PATH}240108+Terminos+y+Condiciones+Trabajo+con+Sentido.pdf`;
        },
        getModeration() {
            // https://ikigai-resources.s3.amazonaws.com/assets/others/Pol%C3%ADtica+de+Moderaci%C3%B3n+de+Ofertas+Laborales+2020+.pdf
            return `${process.env.VUE_APP_ROOT_ASSETS}${process.env.VUE_APP_ASSETS_OTHERS_PATH}Pol%C3%ADtica%20de%20Moderaci%C3%B3n%20de%20Ofertas%20Laborales%202020.pdf`;
        }
    }
};

const currentImg = {
    computed: {
        logo() {
            let path = require("@/assets/images/avatar-default-icon.webp");
            if (this.offer.organization && this.offer.organization.logo && this.offer.organization.logo != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + this.offer.organization.logo;
            }
            return path;
        },
        avatarPath() {
            let path = require("@/assets/images/avatar-default-icon.webp");
            let user = store.getters["users/getUser"];
            if (user && user.avatar && user.avatar != "")
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH  + user.avatar;
            else if (user && user.organization && user.organization.media && user.organization.media.logo && user.organization.media.logo != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + user.organization.media.logo;
            }
            return path;
        },
    },
    methods: {
        getFlag(city) {
            if (city === "Latinoamérica") {
                return flags.find((flag) => flag.name === "Latinoamérica").src;
            }
            if (city) {
                let country = city.substring(city.indexOf("(") + 1, city.indexOf(")"));
                let flag = flags.find(item => item.name === country);
                return flag ? flag.src : null;
            }
            return null;
        },
        getCandidateCountry(candidate) {
            const city = candidate.user.city;
            return city.substring(city.indexOf("(") + 1, city.indexOf(")"));
        },
        getCandidateCity(candidate) {
            const city = candidate.user.city;
            return city.substring(0, city.indexOf("(") - 1);
        },
        getCandidateFlag(candidate) {
            const city = candidate.user.city;
            let flag;
            let country;
            if (city) {
                country = city.substring(city.indexOf("(") + 1, city.indexOf(")"));
                flag = flags.find(flag => flag.name === country);
                return flag.src;
            }
            return null;
        },
        getCover(org) {
            let path = "";
            if (org.media && org.media.cover && org.media.cover != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_COVER_PATH + (org.cover || org.media.cover);
            }
            return path;
        },
        getLogo(obj) {
            let path = require("@/assets/images/avatar-default-icon.webp");
            if (obj.alias && obj.alias !== "") {
                return path;
            }
            if (obj && obj.media) {
                if (obj && obj.media.logo && obj.media.logo !== "") {
                    path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + (obj.media.logo).toString();
                }
            }
            if (obj && obj.organization) {
                if (obj.organization.media.logo && obj.organization.media.logo != "") {
                    path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + (obj.organization.logo || obj.organization.media.logo).toString();
                }
            }
            return path;
        },
        getAvatarPath(user) {
            let path = require("@/assets/images/avatar-default-icon.webp");
            if (user.avatar && user.avatar != "")
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH  + user.avatar;
            else if (user.organization && user.organization.media && user.organization.media.logo && user.organization.media.logo != "") {
                path = process.env.VUE_APP_ROOT_ASSETS + process.env.VUE_APP_ASSETS_LOGO_PATH + user.organization.media.logo;
            }
            return path;
        },
        getBenefits(value) {
            const benefit = benefits.find(item => item.name === value);
            return benefit.src;
        },
        getGoals(goal) {
            return goalsObj[goal - 1];
        },
    }
};

const handleTxt = {
    methods: {
        getInnerText(html) {
            let temp = document.createElement("div");
            temp.innerHTML = html;
            return temp.textContent || temp.innerText || "";
        },
        normalized(str) {
            const chars = {
                "á": "a", "é": "e", "í": "i", "ó": "o", "ú": "u",
                "à": "a", "è": "e", "ì": "i", "ò": "o", "ù": "u", "ñ": "n",
                "ã": "a", "ç": "c",
                "ä": "a", "ë": "e", "ï": "i", "ö": "o", "ü": "u",
                "â": "a", "ê": "e", "î": "i", "ô": "o", "û": "u"

            };
            const expr = /[áàãäâéèëêíìïîóòöôúùüûñç]/ig;
            str = str.toString().toLowerCase();
            return str.replace(expr, (e) => {
                return chars[e];
            });
        }
    }
};

const tools = {
    computed: {
        breakpoint() {
            return this.$vuetify.breakpoint.name;
        },
        vuetify() {
            return this.$vuetify;
        }
    },
    methods: {
        formatterSalary({ range, currency }) {
            const formatter = new Intl.NumberFormat("es-CL", {
                // style: "currency",
                currency: currency,
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
            });

            return { range: [formatter.format(range[0]), formatter.format(range[1])], currency };
        }
    }
};

const datetime = {
    methods: {
        formatterDate(date, format) {
            if (!date) {
                return "--- ∞ ---";
            } else if (format && format === "ddmmyy") {
                if (typeof date === "string") {
                    date = date.substring(0, 10);
                    let splitter = "";

                    if (date.includes("-")) {
                        splitter = "-";
                    } else if (date.includes("/")) {
                        splitter = "/";
                    } else {
                        return "--- ∞ ---";
                    }

                    const [year, month, day] = date.split(splitter);
                    let newDate = new Date(year, month - 1, day);
                    let dd = newDate.getDate().toString().padStart(2, "0");
                    let mm = (newDate.getMonth() + 1).toString().padStart(2, "0");
                    let yy = newDate.getFullYear().toString().slice(-2);
                    return `${ dd }/${ mm }/${ yy }`;
                } else {
                    let dd = date.getDate().toString().padStart(2, "0");
                    let mm = (date.getMonth() + 1).toString().padStart(2, "0");
                    let yy = date.getFullYear().toString().slice(-2);
                    return `${ dd }/${ mm }/${ yy }`;
                }
            } else {
                let newDate;
                let monthAbr = [
                    "ene",
                    "feb",
                    "mar",
                    "abr",
                    "may",
                    "jun",
                    "jul",
                    "ago",
                    "sep",
                    "oct",
                    "nov",
                    "dic"
                ];
                if (typeof date === "string") {
                    date = date.substring(0, 10);
                    if (date.includes("-")) {
                        const [year, month, day] = date.split("-");
                        newDate = new Date(year, month - 1, day);
                        return `${newDate.getDate()}-${monthAbr[newDate.getMonth()]}-${newDate.getFullYear()}`;
                    }
                    if (date.includes("/")) {
                        const [day, month, year] = date.split("/");
                        newDate = new Date(year, month - 1, day);
                        return `${newDate.getDate()}-${monthAbr[newDate.getMonth()]}-${newDate.getFullYear()}`;
                    }
                } else {
                    return `${date.getDay()}-${monthAbr[date.getMonth()]}-${date.getFullYear()}`;
                }
            }
        },
        expirations(date) {
            const today = new Date();
            const createdDate = new Date(date);
            const expireDate = new Date(createdDate.getTime() + (86400000 * process.env.VUE_APP_DAYS_TO_EXPIRE_OFFERS));

            const days = ((expireDate.getTime() - today.getTime()) / (1000 * 3600 * 24)).toFixed();
            return days <= 0 ? 0 : days;
        },
        closePostulations(date) {
            const today = new Date();
            const endDate = new Date(date);

            const days = ((endDate.getTime() - today.getTime()) / (1000 * 3600 * 24)).toFixed();
            return days <= 0 ? 0 : days;
        },
        howOld(birthAt) {
            let day, month, year;
            if (birthAt.includes("/")) {
                [day, month, year] =  birthAt.split("/");
            }
            if (birthAt.includes("-")) {
                [year, month, day] =  birthAt.split("-");
            }
            let birthdayDate = new Date(year, month - 1, day);
            let ageDifMs = Date.now() - birthdayDate.getTime();
            let ageDate = new Date(ageDifMs);
            return Math.abs(ageDate.getUTCFullYear() - 1970);
        },
        howManyTime(date) {
            const now = new Date() / 1000;
            let postDay = date ? new Date(date) / 1000 : null;
            let diff = now - postDay;
            const day = 60 * 60 * 24 ;
            const week = day * 7 ;
            const month = week * 30 ;
            let timeAgo = "", unit = 0;

            if (diff > month) {
                unit = parseInt(diff / month);
                timeAgo = "Hace " + unit + " Mes" + (unit >= 2 ? "es" : "");
            } else if (diff > week) {
                unit = parseInt(diff / week);
                timeAgo = "Hace " + unit + " Semana" + (unit >= 2 ? "s" : "");
            } else if (diff > day) {
                unit = parseInt(diff / day);
                timeAgo = "Hace " + unit + " Día" + (unit >= 2 ? "s" : "");
            } else if (diff > 3600) {
                unit = parseInt(diff / 3600);
                timeAgo = "Hace " + unit + " Hora" + (unit >= 2 ? "s" : "");
            } else {
                unit = parseInt(diff / 60);
                timeAgo = "Hace " + unit + " Minuto" + (unit >= 2 ? "s" : "");
            }
            return timeAgo;
        },
    }
};

const calculateDv = (T) => {
    let M = 0;
    let S = 1;
    for (; T; T = Math.floor(T / 10)) {
        S = (S + (T % 10) * (9 - (M++ % 6))) % 11;
    }
    return S ? S - 1 : "k";
};

const validation = {
    methods: {
        isValidRut(fullRut) {
            if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test(fullRut)) return false;
            let tmp = fullRut.split("-");
            let digv = tmp[1];
            let rut = tmp[0];
            if (digv == "K") digv = "k";
            return calculateDv(rut) == digv;
        }
    }
};

const meta = {
    methods: {
        getMetaInfo(metaData) {
            const defaultData = {
                title: "Trabajo con Sentido",
                description: "Queremos profesionales que trabajen para el mundo, desarrollando propuestas de valor en organizaciones que generan sociedades cada vez más sostenibles",
                image: "https://ikigai-resources.s3.amazonaws.com/assets/images/logo.png",
                imageAlt: "Logo de Trabajo con Sentido",
                url: "https://www.trabajoconsentido.com/",
            };
            const { title, description, image, imageAlt, url } = metaData || defaultData;

            return {
                title: title || defaultData.title,
                meta: [
                    { name: "description", content: description || defaultData.description },
                    { name: "title", content: title || defaultData.title },
                    // Open Graph
                    { property: "og:url", content: url || defaultData.url },
                    { property: "og:type", content: "website" },
                    { property: "og:title", content: title || defaultData.title },
                    { property: "og:description", content: description || defaultData.description },
                    { property: "og:image", content: image || defaultData.image },
                    { property: "og:image:alt", content: imageAlt || defaultData.imageAlt },
                    { property: "og:site_name", content: "Trabajo con Sentido" },
                    { property: "og:locale", content: "es_419" },
                    // Twitter Meta Tags (Twitter usa Open Graph como fallback)
                    { name: "twitter:card", content: "summary" },
                    { name: "twitter:creator", content: "@trabajocsentido" },
                    { name: "twitter:site", content: "@trabajocsentido" },
                ],
            };
        }
    }
};

export {
    datetime,
    currentImg,
    handleTxt,
    currentFile,
    tools,
    validation,
    meta,
};
